
import {setProperty} from '@/utils/reflection'
function createShadow(target){
    return new Proxy({target,freezenProperties:{}}, {
            get: function (raw, key) {
                
                if(Object.hasOwnProperty.call(raw.target, key)){
                    if(!Object.hasOwnProperty.call(raw.freezenProperties, key)){
                        raw.freezenProperties[key] = Object.freeze({
                            ...raw.target[key]
                        })
                    }
                    return raw.freezenProperties[key]
                    
                }
                
            },
            set: function(raw, key, value) { 
                delete raw.freezenProperties[key]
                raw.target[key] = value
                return true
            }
        })
}
const $treeShadow = {
    cacheMap:{},
    get(target){
        let shadow = this.cacheMap[target]
        if(!shadow){
            shadow = createShadow(target)
            this.cacheMap[target] = shadow
        }
        return shadow
    }
}
class Tree{
    constructor(){
        this.reset()
    }
    reset(){
        this._tree = null
        this._data = null
        this._changed = {}
    }
    get tree(){
        return this._tree
    }
    get top(){
        if(this._tree){
            const id = this._tree._id
            const n = this.find(
                id
            )
            return n
        }
        
    }
    find(id){
        const treeShadow = this
        if(treeShadow._data){
            return treeShadow._data[id]
        }
                
    }
    modify(id, value, propertyChain){
        if(this._data[id]){
            let changed = false;
            if(propertyChain){
                const item = this._data[id]
                changed = setProperty(item, propertyChain, value)            
                if(changed){
                    this._changed[id]=item
                }
            }else{
               this._data[id]=value 
               this._changed[id]=value
               changed = true
            }
            
            return changed
        }else{
            throw(`项目(id:${id})不存在，无法修改`)
        }
    }
    getChanged(){
        return Object.values(this._changed) 
    }
    buildTree({tree, data, merge}){
        if(tree){
           this._tree = tree 
        }
        
        if(data){
            if(Array.isArray(data)){
                const obj = {}
                for (let i = 0; i < data.length; i++) {
                    const item = data[i];
                    obj[item._id] = item
                }
                data = obj
            }
            if(merge){
                Object.assign(this._data, data)   
                for (const key in data) {
                    if (Object.hasOwnProperty.call(data, key) && this._changed[key]) {
                        delete this._changed[key]                    
                    }
                }      
            }else{
                this._data = data
                this._changed = {}
            }
        }        
    }
}

export default Tree